import i18n from '@/utils/i18n';
import React from 'react';
import { BaseActionSheet } from '@/components/base-action-sheet';
import {
  IngredientActions,
  MenuItemIngredientForm,
  MenuItemIngredientFormState,
} from './menu-item-ingredient-form';
import { PackUnit } from '@/enums';

interface MenuItemIngredientActionSheetProps {
  action: IngredientActions;
  ingredient?: MenuItemIngredientFormState;
  ingredientName?: string;
  onSubmit: (formState: MenuItemIngredientFormState) => void;
  originalBaseUnit?: PackUnit;
  setShowIngredientForm: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MenuItemIngredientActionSheet: React.FC<
  MenuItemIngredientActionSheetProps
> = ({
  action,
  ingredient,
  ingredientName,
  onSubmit,
  originalBaseUnit,
  setShowIngredientForm,
}) => (
  <BaseActionSheet
    isVisible
    onClose={() => setShowIngredientForm(false)}
    title={i18n.t(
      action === IngredientActions.ADD ? 'add_ingredient' : 'update_ingredient',
    )}
  >
    <MenuItemIngredientForm
      action={action}
      ingredient={ingredient}
      initialIngredientName={ingredientName}
      onSubmit={(formState: MenuItemIngredientFormState) => {
        onSubmit(formState);
        setShowIngredientForm(false);
      }}
      originalBaseUnit={originalBaseUnit}
    />
  </BaseActionSheet>
);
